import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { track } from "../../utils/analytics";   
import "../../styles/GiftOutcome.css";
import "../../styles/buttons.css";

export default function GiftCancelPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const planId       = params.get("plan")         || "unknown";
  const accountType  = params.get("account_type") || "unknown";

  /* ───────── analytics ───────── */
  useEffect(() => {
    // GA4 page view
    track("page_view", {
      page_location: window.location.href,
      page_title   : "Gift Checkout Cancelled",
    });

    // funnel abandonment
    track("gift_purchase_cancel", {
      plan_id     : planId,
      account_type: accountType,
    });
  }, [planId, accountType]);

  /* helper for CTA links */
  const navClick = (label, dest) =>
    track("navigation_click", {
      location   : "gift_cancel",
      nav_item   : label,
      destination: dest,
    });

  return (
    <div className="gift-outcome-container">
      <Link to="/" className="gift-logo" onClick={() => navClick("Logo", "/")}>
        BestDay2Marry
      </Link>

      <div className="gift-message">
        <h1>Purchase Cancelled</h1>
        <p>No worries—your card was not charged.</p>

        <Link
          to="/pricing/couples"
          className="btn btn-primary"
          onClick={() => navClick("Return to Pricing", "/pricing/couples")}
        >
          Return to Pricing
        </Link>
      </div>
    </div>
  );
}